import { DEBOUNCE_MS } from '@/constants/timing';
import { useEffect, useState } from 'react';

export const useDebouncedValue = <T>(
  value: T,
  delayMs = DEBOUNCE_MS.DEFAULT,
): T => {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
};
